
import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "@/components/main-header.vue";
import echarts from "echarts";
import Empty from "@/components/empty.vue";
import { GetKnowledgeList, GetTupu } from "@/request/knowledge";
@Component({
  components: {
    MainHeader,
    Empty,
  },
})
export default class Name extends Vue {
  private data: any = {};
  private cTab: any = "通用";
  private tupuData: any = {};
  private showTupu: any = false;
  private colors: any = [
    "#FFA7CC",
    "#46AAAA",
    "#FFAA6A",
    "#A185D3",
    "#82D1F1",
    "#EC7E68",
    "#F6C63C",
    "#7784A2",
    "#75DDB5",
    "#759FFC",
    "#FFA7CC",
    "#46AAAA",
    "#FFAA6A",
    "#A185D3",
    "#82D1F1",
    "#EC7E68",
    "#F6C63C",
    "#7784A2",
    "#75DDB5",
    "#759FFC",
    "#FFA7CC",
    "#46AAAA",
    "#FFAA6A",
    "#A185D3",
    "#82D1F1",
    "#EC7E68",
    "#F6C63C",
    "#7784A2",
    "#75DDB5",
    "#759FFC",
    "#FFA7CC",
    "#46AAAA",
    "#FFAA6A",
    "#A185D3",
    "#82D1F1",
    "#EC7E68",
    "#F6C63C",
    "#7784A2",
    "#75DDB5",
    "#759FFC",
  ];
  private getWidth() {
    const ele: any = document.getElementById("scrollBox");
    if (ele && ele.clientWidth) {
      return ele.clientWidth + "px";
    } else {
      return 0;
    }
  }
  private getDetail() {
    const params: any = {
      params: {
        id: this.data.id,
        need_attr_split: true,
      },
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetKnowledgeList(this, params, loading).then((res: any) => {
      loading.close();
      this.data = res;
      const d: any = {
        entity_id: res.id,
        entity_name: res["实体名称"],
        entity_type: res["语义类型"],
      };
      this.drawTupu(d);
    });
  }
  private drawTupu(d: any) {
    this.showTupu = false;
    const params: any = {
      params: {
        entity_id: d.entity_id,
        entity_name: d.entity_name,
        entity_type: d.entity_type,
      },
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetTupu(this, params).then((data: any) => {
      loading.close();
      this.tupuData = data;
      this.showTupu = true;
      data.nodes.forEach((ele: any, index: any) => {
        if (ele.type === "目标") {
          ele.symbol = "roundRect";
          ele.symbolSize = 25;
        } else if (ele.type === "实体") {
          ele.symbolSize = 20;
        } else {
          ele.symbolSize = 1;
        }
      });
      const Chart: any = echarts.init(this.$refs.Echarts1 as HTMLCanvasElement);
      const options: any = {
        color: this.colors,
        title: {
          text: "",
          subtext: "",
          top: "bottom",
          left: "right",
        },
        tooltip: {},
        legend: [
          {
            // selectedMode: 'single',
            data: data.categories.map(function (a: any) {
              return a.name;
            }),
          },
        ],
        animationDuration: 1500,
        animationEasingUpdate: "quinticInOut",
        series: [
          {
            name: "",
            type: "graph",
            layout: "force",
            data: data.nodes,
            links: data.links,
            categories: data.categories,
            zoom: 3,
            roam: true,
            label: {
              show: true,
              position: "inside",
              formatter: "{b}",
            },
            edgeLabel: {
              show: true,
              formatter: (res: any) => {
                return res.data.name;
              },
            },
            edgeSymbol: ["", "arrow"],
            lineStyle: {
              color: "source",
              width: 1,
              curveness: 0.1,
            },
            emphasis: {
              show: false,
              focus: "adjacency",
              lineStyle: {
                width: 6,
              },
            },
          },
        ],
      };
      Chart.setOption(options, true);
      // 点击事件
      Chart.off("click");
      Chart.on("click", (p: any) => {
        const data: any = {
          entity_id: p.id,
          entity_name: p["name"],
          entity_type: p["category"],
        };
        // this.drawTupu(data);
      });
    });
  }
  private changePart(index: any) {
    const parant: any = document.getElementById("scrollBox");
    const children: any = document.getElementById("scrollBox" + index);
    if (parant) {
      if (children) {
        const parentTop = parant.offsetTop;
        const childTop = children.offsetTop;
        parant.scrollTop = childTop - parentTop - 14;
      }
    }
  }
  private mounted() {
    if (this.$route.query.id) {
      this.data.id = this.$route.query.id;
      this.getDetail();
    }
  }
}
